import React from "react";
import { Link } from "react-router-dom";
import "./ThankYouCareers.css";

const ThankYouCareers = () => {
    return (
        <div>
            <div className="thank-you-container">
                <img
                    src="/assets/images/task.png"
                    alt="Thank you icon"
                    className="thank-you-icon"
                />
                <h1>
                    Application Submitted Successfully!
                </h1>
                <p className="subtext">
                    Thank you for applying to join Team Ambrum!
                    We’ve received your application and our team will review it shortly. If your profile matches what we're looking for, you’ll hear from us soon. 
                    Until then, stay inspired and keep building your story
                    Just like we do every day at Ambrum.
                </p>
                <Link to="/" className="home-button">
                    <span>❮</span> Home
                </Link>
            </div>
        </div>
    );
};

export default ThankYouCareers;
